<template>
  <svg width="128" height="129" viewBox="0 0 128 129" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M64.2167 0.878418L119.797 32.8784V96.8784L64.2167 128.878L8.63672 96.8784V32.8784L64.2167
         0.878418ZM113.797 36.3329L64.2167 7.78738L14.6367 36.3329V93.4239L64.2167 121.969L113.797
         93.4239V36.3329Z" fill="#160C56"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M64.2167 121.97V93.4241V64.8786L39.4267 50.6059L14.6367 36.3331V64.8786V93.4241L64.2167
         121.97Z"
      fill="white"
    />
    <path
      d="M89.0067 107.697L113.797 93.4241L89.0067 79.1514L64.2167 93.4241V121.97L89.0067 107.697Z"
      fill="#87E0E1"
    />
    <path d="M64.2167 64.8786V93.4241L89.0067 79.1514L64.2167 64.8786Z" fill="#1B46DD"/>
    <path
      d="M89.0067 50.6059L64.2167 64.8786L89.0067 79.1514L113.797 64.8786L89.0067 50.6059Z"
      fill="#B068E9"
    />
    <path
      d="M89.0067 22.0604L64.2167 7.7876L39.4267 22.0604L14.6367 36.3331L39.4267 50.6059L64.2167
         36.3331L89.0067 50.6059L113.797 36.3331L89.0067 22.0604Z" fill="#F9DB4E"/>
    <path
      d="M64.2167 64.8786L89.0067 50.6059L64.2167 36.3331L39.4267 50.6059L64.2167 64.8786Z"
      fill="#E94A5D"
    />
  </svg>
</template>

<script>
export default {
  name: 'TerragruntIcon',
};
</script>
